import { useRef } from 'react';
import Body from '@/components/Privacidad/Body';
import Footer from '@/components/Footer';
import getMetadata from '@/utils/getMetadata';
import { NextSeo } from 'next-seo';
import localeManager from '@/utils/localeManager';
import useLangMenuBar from "@/hooks/useLangMenuBar";

const PoliticasDeprivacidad = ({ locale, footer, menu }) => {
  const root = useRef();
  useLangMenuBar(menu)

  return (
    <main ref={root} className="relative site-max mx-auto privacidad">
      <NextSeo
        {...getMetadata({
          locale,
          title: 'Polítias de privacidad',
          description: 'Conocé nuestras políticas de privacidad.',
          pathname: '/politicas-de-privacidad'
        })}
      />
      <Body />
        <Footer footer={footer} locale={locale} />
    </main>
  );
};

export default PoliticasDeprivacidad;

export async function getServerSideProps({ req, locale: nextLocale, defaultLocale }) {
  const { locale, dict } = await localeManager.getLocaleResources(req, {}, nextLocale || defaultLocale);

  return {
    props: {
      locale,
      footer: dict.home.footer,
      menu: dict.menu
    }
  };
}
